import React from "react";

function SubscriptionSection() {
  return (
    <section className="subscribe-section bg-blue pt-210 rpt-150 pb-90 rpb-85">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="section-title text-white mb-25 rmt-35 wow fadeInLeft delay-0-2s">
              <h2>
                Next Cosmos Technology provides Solutions for scalable custom
                software development that are tailored to your business needs
              </h2>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <form
              className="subscribe-form mb-15 wow fadeInRight delay-0-2s"
              action="#"
            >
              <input type="email" placeholder="Your Email Address" required />
              <button type="submit">Subscribe</button>
            </form>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default SubscriptionSection;
